import React, { useEffect } from 'react'

export default function GameEvents({events, onLoad}) {
  useEffect(() => {
    onLoad()
  }, [])

  if (!events) return <div className='animated-spinner'></div>

  return <table className='table table-striped'>
    <thead>
      <tr>
        <th>Time</th>
        <th>User</th>
        <th>Activity</th>
      </tr>
    </thead>
    <tbody>
      { 
        events.map(event => {
          return <tr key={event.id}>
            <td>{event.date}</td>
            <td>{event.user}</td>
            <td>{event.description}</td>
          </tr>
        })
      }
    </tbody>
  </table>
}
